import React from 'react'
import AboutMeLeftContent from '../Components/AboutMeLeftContent'
import AboutMeRightContent from '../Components/AboutMeRightContent'


const AboutMePage = () => {
  return (
    <>
      <div style={{ display: "flex", flexDirection: "row", height: "100%", width: "100%", justifyContent: "space-between", gap: "20px" }}>

        {/* Left Section */}
        <div style={{ width: "50%" }} className='card'>
          <AboutMeLeftContent />
        </div>

        {/* Right Section (ABOUT ME) */}
        <div style={{ height: "100%", width: "100%", backgroundColor: "#313139", color: "#fff" }} className='card p-2'>
          <AboutMeRightContent />
        </div>
      </div>
    </>
  )
}

export default AboutMePage